<template>
    <div>
        <div class="flex p-20 justify-center">
            <icon icon="lock" size="8x" class="opacity-25" spin></icon>
        </div>

        <modal ref="modal" :disable-close="true" :content-class="'md:p-5 md:w-3/4 lg:w-3/4 md:mt-10 md:mb-20'">
            <div class="h-full overflow-y-auto">
                <float-button ref="logout" class="bg-red-400 m-5" @click.prevent="logout()">
                    <icon icon="times"></icon>
                </float-button>

                <div v-if="loading" class="flex w-full h-full items-center justify-center">
                    <div class="loader"></div>
                </div>

                <div class="flex flex-col h-full" v-if="!loading && !iframeUrl">
                    <div class="w-full md:rounded-t bg-red-600 p-4 text-center">
                        todos os planos com <span class="font-bold underline">50% de desconto</span> <br>até o dia <span class="font-bold underline">{{ promoEnd }}</span>
                    </div>

                    <div class="w-full">
                        <div class="py-5 px-10 md:p-5 bg-purple-900 flex w-full justify-center">
                            <select name="period" class="input period uppercase text-center w-full md:w-6/12" v-model="period" @change="setPlansByPeriod(period)">
                                <option :value="plans.period" v-for="(plans, k) in plansPeriods" :key="k">{{ plans.period_name }} ({{ plans.discount }})</option>
                            </select>
                        </div>
                    </div>

                    <div class="w-full h-full">
                        <div class="flex flex-col md:flex-row h-full bg-gray-300">
                            <div class="plan p-10 md:p-5 bg-white w-full" v-for="(plan, k) in plans"
                                 :key="k" :class="{'featured': plan.featured}">

                                <div class="grid">
                                    <div class="flex-none">
                                        <h1>{{ plan.name }}</h1>

                                        <div>
                                            <span class="text-2xl opacity-25 line-through">{{ plan.old_price }}</span>
                                        </div>
                                        <div>
                                            <span class="uppercase">{{ plan.currency }} </span>

                                            <span class="text-4xl">{{ plan.price }}</span> /
                                            <span class="lowercase">{{ plan.period_name }}</span>
                                        </div>
                                    </div>

                                    <div class="features font-light flex-shrink">
                                        <div v-for="(feature, k) in plan.features" :key="k">
                                            <div class="feature p-1 border-b uppercase"  v-if="feature.value !== false" :class="{'featured': feature.featured}">
                                                {{ feature.name }}
                                            </div>
                                        </div>
                                    </div>

                                    <button class="btn self-end" @click="subscribe(plan.slug)">
                                        {{ $t('subscribe') }}
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="iframeUrl" class="text-black flex h-full">
                    <iframe class="h-full w-full" :src="iframeUrl" frameborder="0"></iframe>
                </div>
            </div>
        </modal>
    </div>
</template>

<style scoped>
    .period {
        text-align-last:center;
    }

    .plan {
        @apply text-center w-full text-gray-700 font-light;
    }

    .plan .features {
        @apply py-5;
    }

    .plan.featured {
        @apply bg-purple-900 text-white font-bold;
    }

    .plan.featured .feature {
        @apply border-purple-800;
    }

    .featured .btn {
        @apply bg-orange-600;
    }

    .feature.featured {
        @apply font-bold underline;
    }

</style>

<script>
    import {Auth, Zapin} from "@/services/Api";
    import {dt} from "@/i18n";

    export default {
        data() {
            const promoEnd = dt().format('DD/MM/YYYY');

            return {
                loading: false,
                period: 1,
                plans: [],
                plansPeriods: [],
                iframeUrl: null,
                promoEnd
            }
        },

        mounted() {
            this.$refs.modal.open();

            if(window.appConfig?.revenue?.plans_url) {
                this.iframeUrl = window.appConfig?.revenue?.plans_url;
            } else {
                this.loadPlans();
            }

            if(Auth.currentUser().hasSubscription() && Auth.currentUser().subscriptionIsActive()) {
                this.$router.push({
                    name: 'Dashboard'
                })
            }
        },

        methods: {
            changePeriod() {
                this.loadPlans(this.period);
            },

            loadPlans() {
                this.loading = true;

                Zapin
                    .plans()
                    .byPeriods()
                    .then(res => {
                        this.plansPeriods = res.data;

                        this.setPlansByPeriod(this.plansPeriods[0].period);
                    })
                    .catch((e) => {
                        console.log(e)
                        alert(this.$t('error_occurred_try_again'));
                    })
                    .finally(() => this.loading = false);
            },

            setPlansByPeriod(period) {
                this.plans = [];

                this.plansPeriods.forEach((plans) => {
                    if(plans.period === period) {
                        this.plans = plans.plans;
                    }
                })

                this.period = period;
            },

            subscribe(plan) {
                this.$router.push({
                    name: 'Subscribe',
                    params: {
                        plan: plan
                    }
                });
            },

            logout() {
                if(confirm(this.$t('are_you_sure_logout'))) {
                    Auth.logout();
                }
            }
        }
    }
</script>